import { AttachmentEntityInterface, UserEntityInterface } from '@types';
import { LangEnum } from '@enums';

export type SubmissionEnvironmentState = {
  employeeNumber: number;
  context: any;
  attachments: AttachmentEntityInterface[];
  attachmentsExecuted: AttachmentEntityInterface[];
  submissionUser: UserEntityInterface;
  rendererWidth?: number;
  scale?: number;
  isDownload?: boolean;
  personnelDepPlEmail?: string;
  numberOfCountries: number;
  numberOfProjects: number;
  lang: LangEnum;
};

export const submissionEnvironmentInitialState: SubmissionEnvironmentState = {
  submissionUser: null,
  context: null,
  attachments: [],
  attachmentsExecuted: [],
  employeeNumber: null,
  scale: 1,
  rendererWidth: 1000,
  isDownload: false,
  personnelDepPlEmail: 'personneldepartment.poland@ventionteams.com',
  numberOfCountries: 11,
  numberOfProjects: 300,
  lang: LangEnum.ENG,
};
